import * as React from "react";
const SvgTypeSpecimen = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "M4 6H2v16h16v-2H4z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22 2H6v16h16V2zm-5.37 12.5-.8-2.3H12.2l-.82 2.3H9.81l3.38-9h1.61l3.38 9h-1.55z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "m13.96 7.17-1.31 3.72h2.69l-1.3-3.72z",
  fill: "currentColor"
}));
export default SvgTypeSpecimen;